import { render, staticRenderFns } from "./IeltsList.vue?vue&type=template&id=a4809e14&scoped=true"
import script from "./IeltsList.vue?vue&type=script&lang=js"
export * from "./IeltsList.vue?vue&type=script&lang=js"
import style0 from "./IeltsList.vue?vue&type=style&index=0&id=a4809e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4809e14",
  null
  
)

export default component.exports